import React, { FC, PropsWithChildren } from 'react'
import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'
import { Grid, Hidden } from '@mui/material'

import { LDContainerV2FSMProps } from '../../../types/interface/layouts.interface'
import { BrandedHeaderShared, FSMBreadcrumbs, Typography } from '@dg-shared'

const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    minHeight: '100vh',
    backgroundColor: theme.brand.colors.background,
    justifyContent: 'center',
    alignContent: 'start',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(1),
      paddingBottom: theme.spacing(4),
    },
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      minWidth: '750px',
      paddingBottom: theme.spacing(5),
    },
  },
  bodyContainer: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      maxWidth: '968px',
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    height: '80px',
    justifyContent: 'space-around',
  },
  title: {
    marginBottom: theme.spacing(3),
  },
}))

const LDContainerV2: FC<PropsWithChildren<LDContainerV2FSMProps>> = ({
  send,
  children,
  breadcrumbsBtnText,
  breadcrumbsStepPercentage,
  breadcrumbsBackHandler,
  breadcrumbs = false,
  title,
}) => {
  const { classes } = useStyles()

  return (
    <Grid container component='article' className={classes.container}>
      <Hidden mdUp={false} mdDown={true}>
        <Grid item xs={12} className={classes.header}>
          <BrandedHeaderShared />
        </Grid>
      </Hidden>
      <Grid item xs={12}>
        {breadcrumbs && (
          <FSMBreadcrumbs
            send={send}
            breadcrumbsBackHandler={breadcrumbsBackHandler}
            buttonText={breadcrumbsBtnText}
            stepsPercentage={breadcrumbsStepPercentage}
          />
        )}
      </Grid>

      <Grid item xs={12} className={classes.bodyContainer}>
        {title && (
          <Typography type='h1' className={classes.title}>
            {title}
          </Typography>
        )}
        {children}
      </Grid>
    </Grid>
  )
}
export default LDContainerV2
